import { render, staticRenderFns } from "./AboutBD.vue?vue&type=template&id=3a0e1ce0&"
import script from "./AboutBD.vue?vue&type=script&lang=js&"
export * from "./AboutBD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports